<template>
  <div id="app">
   <transition name="show-from-left">
        <popover name="helphealth" :width="240">
            <Help :titleChart="titleChartMap"> 
            <div slot="content">
              <div v-show='!showMatriz'>
                <!-- MAPA -->
                <p>{{ $t("114") }}</p>
                <p><b>{{ $t("115") }}</b></p>
                <div class="form_failure_rate col-lg-12 col-xs-12" >
                  <div class="col-lg-3 col-xs-3" style="padding-top:5px;">
                  fr = 
                  </div>
                  <div class="col-lg-9 col-xs-9">
                    <div class="col-lg-12 col-xs-12" style="border-bottom:1px solid #fff; text-align:center;">
                      (ni*1)+(na*0.5)
                    </div>
                    <div class="col-lg-12 col-xs-12" style="text-align:center;">
                      nt
                  </div>
                  </div>
                </div>
                <p>{{ $t("116") }} <b style="color:#68B3C8" >ni</b> = {{ $t("117") }} <b style="color:#68B3C8">na</b> = {{ $t("118") }} <b style="color:#68B3C8" >nt</b> = {{ $t("119") }}

                <p><b style="color:#68B3C8">{{ $t("120") }}</b> {{ $t("121") }} <b style="color:#68B3C8">{{ $t("122") }}</b> {{ $t("123") }}</p>
  

              </div>
            </div>     
          </Help>
        </popover>
    </transition>

    <transition name="show-from-left">
        <popover name="helpmatrix" :width="240">
            <Help :titleChart="titleChartMap"> 
            <div slot="content">
              <div v-show='showMatriz'>
                {{ $t("124") }}
              </div>
            </div>     
          </Help>
        </popover>
    </transition>

    <div class="title-charts title-bt-help">{{name_chart}}
      <button v-show='!showMatriz' class="bt-help" v-popover:helphealth.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <div class="title-charts title-bt-help">{{name_chart}}
      <button v-show='showMatriz' class="bt-help" v-popover:helpmatrix.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <div class="bt-change-charts">
      <toggle-button :value="true" :width="60" :labels="{checked: 'On', unchecked: 'Off'}" @change="btChangeStart()" v-model="changeStart"/>
    </div>

    <div class="space">&nbsp;</div>

    <transition name="fade">
    <!-- <highmaps ref="highcharts" :options="mapOptions"></highmaps> -->
    <div :id='id'  v-show='!showMatriz'  @mouseover="mouseOver" @mouseleave="mouseleave"></div>
    </transition>

    <transition name="fade">
      <div v-show='showMatriz'  @mouseover="mouseOver" @mouseleave="mouseleave">
        <div v-show='showLoading' class="actLoading">Loading ...</div>
        <div class="matrix-box" v-html="boxMatriz"></div>     
      </div>
    </transition>

    <div id='buttons' class="btn-group btn-group-sm" role="group" aria-label="Buttons">
      <button type="button" class="btn btn-secondary" @click="getMatrizChart()"><small>{{ btn_title }}</small></button> 
    </div>
    
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import Vue from 'vue'
import axios from 'axios';

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

let Highcharts = require('highcharts/highmaps');

import json from '../../../../js/world-continent.json';

Highcharts.theme = {
    colors: ['#2b908f', '#90ee7e', '#f45b5b', '#7798BF', '#aaeeee', '#ff0066',
        '#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
    chart: {
        backgroundColor: 'rgba(0,0,0,0)',
        // {
        //     linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
        //     stops: [
        //         [0, '#2a2a2b'],
        //         [1, '#3e3e40']
        //     ]
        // },
        style: {
            fontFamily: '\'Unica One\', sans-serif'
        },
        plotBorderColor: '#606063',
        marginTop: 50,
        marginBottom: 50
    },
    title: {
        style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '20px'
        }
    },
    subtitle: {
        style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
        }
    },
    xAxis: {
        gridLineColor: '#707073',
        labels: {
            style: {
                color: '#E0E0E3'
            }
        },
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        title: {
            style: {
                color: '#A0A0A3'
            }
        }
    },
    yAxis: {
        gridLineColor: '#707073',
        labels: {
            style: {
                color: '#E0E0E3'
            }
        },
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        tickWidth: 1,
        title: {
            style: {
                color: '#A0A0A3'
            }
        }
    },
    tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        style: {
            color: '#F0F0F0'
        }
    },
    plotOptions: {
        series: {
            dataLabels: {
                color: '#F0F0F3',
                style: {
                    fontSize: '13px'
                }
            },
            marker: {
                lineColor: '#333'
            }
        },
        boxplot: {
            fillColor: '#505053'
        },
        candlestick: {
            lineColor: 'white'
        },
        errorbar: {
            color: 'white'
        }
    },
    legend: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        itemStyle: {
            color: '#E0E0E3'
        },
        itemHoverStyle: {
            color: '#FFF'
        },
        itemHiddenStyle: {
            color: '#606063'
        },
        title: {
            style: {
                color: '#C0C0C0'
            }
        }
    },
    credits: {
        style: {
            color: '#666'
        }
    },
    labels: {
        style: {
            color: '#707073'
        }
    },
    drilldown: {
        activeAxisLabelStyle: {
            color: '#F0F0F3'
        },
        activeDataLabelStyle: {
            color: '#F0F0F3'
        }
    },
    navigation: {
        buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
                fill: '#505053'
            },
        },
    },
    // scroll charts
    rangeSelector: {
        buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
                color: '#CCC'
            },
            states: {
                hover: {
                    fill: '#707073',
                    stroke: '#000000',
                    style: {
                        color: 'white'
                    }
                },
                select: {
                    fill: '#000003',
                    stroke: '#000000',
                    style: {
                        color: 'white'
                    }
                }
            }
        },
        inputBoxBorderColor: '#505053',
        inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
        },
        labelStyle: {
            color: 'silver'
        }
    },
    navigator: {
        handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
        },
        outlineColor: '#CCC',
        maskFill: 'rgba(255,255,255,0.1)',
        series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
        },
        xAxis: {
            gridLineColor: '#505053'
        }
    },
    scrollbar: {
        barBackgroundColor: '#808083',
        barBorderColor: '#808083',
        buttonArrowColor: '#CCC',
        buttonBackgroundColor: '#606063',
        buttonBorderColor: '#606063',
        rifleColor: '#FFF',
        trackBackgroundColor: '#404043',
        trackBorderColor: '#404043'
    },
    mapNavigation: {
        enabled: true,
        enableButtons: false
    },
};

// Apply the theme
Highcharts.setOptions(Highcharts.theme);

export default {
  props:{
      id: String,
  },
  components: {
    Help
  },
  data () {
    return {
      changeStart: false,
      titleChartMap: this.$t("125"),
      showLoading: true,
      showMatriz: false,
      activeMatriz: false,
      btn_title: this.$t("126"),
      name_chart: this.$t("125"),
      boxMatriz: '',
      chart: undefined,
      mapOptions: {
          chart: {
              // map: 'custom/world',
            //   map: 'custom/world-continents',
              map: json,
            //   width: 1400,
            //   height: 500,
              renderTo: this.id
          },

          title: {
              text: ''
          },

          legend: {
              title: {
                  text: "",
              }
          },

          mapNavigation: {
              enabled: true,
              buttonOptions: {
                  verticalAlign: 'top'
              }
          },

          tooltip: {
              headerFormat: '',
              // pointFormat: '<b>{point.name}</b><brLat: {point.lat:.2f}, Lon: {point.lon:.2f}'
              pointFormat: '<b>{point.pid}</b><br>'+this.$t("127")+' {point.value} %'
          },

          colorAxis: {
              showInLegend: false,
              min: 0,
              max: 100,
              stops: [
                  // [0, '#009900'],
                  // [0.05, '#009900'],
                  // [0.051, '#fbdb0c'],
                  // [0.07, '#fbdb0c'],
                  // [0.071, '#e3170d'],
                  // [1, '#e3170d'],
                  [0, '#90ed7d'],
                  [0.05, '#90ed7d'],
                  [0.051, '#e4d354'],
                  [0.07, '#e4d354'],
                  [0.071, '#f45b5b'],
                  [1, '#f45b5b']
              ],
          },

          series: [{
              name: 'Basemap',
              borderColor: '#A0A0A0',
              nullColor: 'rgba(217, 217, 217)',
              showInLegend: false,
              // joinBy: ['iso-a2', 'code'],
              data: []
          }],
          credits: {
            enabled: false
          },
          loading: {
              labelStyle: {
                  color: 'black',
                  textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
              },
              style: {
                  backgroundColor: 'none',
                  opacity: 1
              }
          },
      },
    }
  },
  methods: {
    mouseOver(elem) {
      var self = this
      if(self.changeStart == true){
        clearInterval(self.interval)
      }     
    },
    mouseleave(elem) {
      var self = this
      if(self.changeStart == true){
        self.btChangeStart()
      }
    },
    btChangeStart () {
      var self = this
      if(self.changeStart == true){
        self.interval = setInterval(function(){ 
          self.showMatriz = !self.showMatriz;
          self.activeMatriz = !self.activeMatriz;
          self.btn_title = self.showMatriz ? this.$t("125") : this.$t("126")

          self.name_chart = self.showMatriz ? this.$t("126") : this.$t("125")

          if(self.showMatriz){
            self.titleChartMap = this.$t("126")  
          } else{
            self.titleChartMap = this.$t("125")
          }
        }, 6000);
       
      } else{
        clearInterval(self.interval)
      }
    },
    getMatrizChart () {
      this.showMatriz = !this.showMatriz;
      this.activeMatriz = !this.activeMatriz;
      this.btn_title = this.showMatriz ? this.$t("125") : this.$t("126")

      this.name_chart = this.showMatriz ? this.$t("126") : this.$t("125")

      if(this.showMatriz){
        this.titleChartMap = this.$t("126")   
      } else{
        this.titleChartMap = this.$t("125")
      }

    },
    getPoints() {
        let data = [];
        let self = this;

        const API = process.env.ROOT_API

        this.chart.showLoading();

        axios({method: 'GET', url: API + `v1/mysemeq-ambev/get-health-indicator?region=GLB&tipo=offline&planta=&year=${this.filters.year}&period=AC&technique=`, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function (response) {
                for(let i in response.data){
                    data.push({
                        // 'name': response.data[i].p,
                        'pid': response.data[i].city,
                        'value': response.data[i].tpm,
                        'lat': response.data[i].lat,
                        'lon': response.data[i].lng,
                        'color': response.data[i].cl
                    })
                }

                self.chart.addSeries({
                    type: 'mappoint', 
                    enableMouseTracking: true,
                    colorKey: 'color',
                    name: 'Cities',
                    showInLegend: false,
                    zIndex: 7,
                    data: data
                });
                // self.chart.series[1].setData(data);

                self.chart.hideLoading();
            })
            .catch(function (error){
                console.log(error)
                self.chart.showLoading('Error');
            })


    },
    getWorldMap() {
        let data = []
        let self = this;

        const API = process.env.ROOT_API

        this.chart.showLoading();

        axios({method: 'GET', url: API + 'v1/mysemeq-ambev/get-health-indicator-glb?region=GLB&tipo=offline', headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(function (response){
            for (let i in response.data){
                let c = '';
                if(response.data[i].pid == 'AFR') { c='af' }
                else if(response.data[i].pid == 'APAC') { c='as' }
                else if(response.data[i].pid == 'EUR') { c='eu' }
                // else if(response.data[i].pid == 'MAZ') { c='as' }
                else if(response.data[i].pid == 'NAZ') { c='na' }
                else if(response.data[i].pid == 'SAZ') { c='sa' }
                
                data.push({
                    'hc-key': c,
                    'value': response.data[i].tpm,
                    'pid': response.data[i].pid
                });
            };

            self.chart.addSeries({
                name: 'Basemap',
                borderColor: '#000',
                nullColor: 'rgba(217, 217, 217)',
                showInLegend: false,
                data: data
            });
            self.chart.hideLoading();
        })
        .catch(function (error){
            console.log(error);
            self.chart.showLoading('Error');
        })
    },
    getMatriz() {
        let self = this;       

        const API = process.env.ROOT_API

        axios({method: 'GET', url: API + `v1/mysemeq-ambev/matrixHtml?corporation_id=1&region=${this.filters.region}&plant_id=${this.filters.plant}&year=${this.filters.year}&period=${this.filters.period}`, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(function (response){
          self.boxMatriz = response.data
          self.showLoading = false            
        })
        .catch(function (error){
            console.log(error);
        })
    }
  },
  computed: {
    ...mapGetters(['filters']),
  },
  watch: {
    filters: function(newValue){
      this.showLoading = true
      this.getMatriz(); 
    }
  },
  mounted() {
    this.chart = Highcharts.mapChart(this.mapOptions);
    this.getPoints();
    this.getWorldMap();       
  },
  created() {
  }
}
</script>

<style scoped>


.matrix-box{
  height: 415px;
  overflow: auto; 
  margin: 20px auto 0px auto;
  width: 90%;
}

.matrix-box table{
  margin: 0px auto!important;
  width: 90%!important;
}


#buttons{
  position: absolute;
  left: 10px;
  top: 8px;
  z-index: 25;
  height: 20px;
  align-items: center;
}

.btn{ 
  background-color: #000;
  color: #66615b;
  font-weight: 800;
}

.activeMatriz{ 
  background-color: #66615b !important;
  color: #eee!important;
}
.fade-enter-active {
  transition: opacity .8s;
}

.fade-leave-active {
  display: none;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
.actLoading{
  font-size: 16px;
  font-weight: bold;
  color:#000;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
  margin: 165px auto 0px auto;
  position: absolute;
  text-align: center;
  width: 92%;
}

.title-bt-help{
  z-index: 999999;
  position: absolute;
  left: 44%;
}

div[data-popover="helphealth"] {
  left: 58% !important;
  top: 4% !important;
}

div[data-popover="helpmatrix"] {
  left: 58% !important;
  top: 4%!important;
}

.form_failure_rate{
/*  border: 1px solid #ddd;*/
  padding: 5px 0px;
}

.bt-change-charts{
  position: absolute;
  right: 13px;
  top: 11px;
  z-index: 23;
  height: 20px;
}
 @media screen and (max-width: 1370px) {
  .matrix-box{
    /*width: 550px; */ 
  }
 }

 @media screen and (max-width: 650px) {
  .title-bt-help{
    left: 35%;
  }
}
 @media screen and (max-width: 420px) {
    .title-bt-help{
      top:13%;
      left: 30%;
    }
    .matrix-box{
      margin-top: 70px;
    }
    .space{
      margin-top: 50px;
      margin-bottom: 25px;
      float: right;
      width: 100%;
    }
 }

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Maps/MapChart.vue